import { observable, computed, action, runInAction, asMap } from 'mobx'

import { getAboutData } from 'transport/about'

import UiStore from 'stores/UiStore'

class AboutStore {
  @observable contacts = []

  @observable tags = []

  @observable groups = []

  @observable desc = asMap({})

  @computed get selectedGroup () {
    return this.groups[0]
  }

  @computed get selectedGroupName () {
    return this.selectedGroup && this.selectedGroup.name
  }
  @computed get selectedGroupDesc () {
    return this.selectedGroup && this.selectedGroup.description
  }

  @computed get visibleContacts () {
    if (UiStore.selectedContact !== null) {
      return [UiStore.selectedContact]
    }

    return UiStore.inAboutDetailView
      ? this.contacts.filter(c =>
          UiStore.selectedTag.contacts.some(d => d.id === c.id))
      : this.contacts
  }

  @computed get visibleTags () {
    return this.tags
  }

  tagWithId (id) {
    return this.tags.find(tag => tag.id === id)
  }

  contactGroupForTag (tag) {
    return this.groups.find(group => this.tagsWithinGroup(group).includes(tag))
  }

  @action selectTagWithId (id) {
    const tag = this.tagWithId(id)
    UiStore.selectedContactGroup = this.contactGroupForTag(tag).name
    UiStore.selectedTag = tag
    UiStore.selectedContact = null
  }

  @action async fetchData () {
    const response = await getAboutData()
    runInAction(() => {
      this.contacts = response.contacts
      this.tags = response.tags
      this.groups = response.groups
      this.desc = response.desc
    })
  }
}

const singleton = new AboutStore()
export default singleton



// WEBPACK FOOTER //
// ./resources/assets/js/stores/AboutStore.js